import styled from 'styled-components';

export const StyledVerticalSpacer = styled.div<{ margin: string }>`
  border: 0.5px solid ${(p) => p.theme.colors.beyondGrey};
  opacity: 0.5;
  margin: ${(p) => p.margin};
`;
